<div class="sk-category-group-container" [innerText]="optionTitle">
  <!--{{optionTitle}}-->
</div>
